module.exports = __webpack_public_path__ + "img/card-b3.d53b7009.png";